import React from 'react';
import { BeefCutoutChart } from '../components/BeefCutoutChart';
import { BeefCutoutTable } from '../components/BeefCutoutTable';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
export function MarketIQ() {
  return <MarketIQLayout activeSection="beef" data-id="element-438">
      <BeefCutoutChart data-id="element-439" />
      <MarketIQNav current="beef" data-id="element-440" />
      <BeefCutoutTable data-id="element-441" />
    </MarketIQLayout>;
}